module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-S-shadow.d985024e.png";